module.exports = __webpack_public_path__ + "static/media/S32_W.7b78662d.png";